module.exports = __webpack_public_path__ + "img/page_head_04.abc51add.png";